import React from 'react';

export const SkillList = () => {
  return (
    <div className='skills-grid'>
      <li className='skill-item skill-item-advance'>HTML 5 & CSS</li>
      <li className='skill-item skill-item-advance'>Javascript</li>
      <li className='skill-item skill-item-advance'>Node.js</li>
      <li className='skill-item skill-item-intermediate'>React JS</li>
      <li className='skill-item skill-item-intermediate'>Git, CI/CD</li>
      <li className='skill-item skill-item-intermediate'>Python</li>
      <li className='skill-item skill-item-intermediate'>Flask</li>
      <li className='skill-item skill-item-intermediate'>MongoDB</li>
      <li className='skill-item skill-item-intermediate'>SQL</li>
      <li className='skill-item skill-item-beginner'>PHP & Wordpress</li>
      <li className='skill-item skill-item-learning'>React Native</li>
      <li className='skill-item skill-item-learning'>GOLang</li>
    </div>
  );
};
